<app-radio-group
	label="Deposit holder"
	orientation="grid"
	[items]="depositHolders"
	name="depositHolders"
	[ngModel]="depositHolder"
	(ngModelChange)="onDepositHolderChange($event)"
>
</app-radio-group>
